import type { ReactElement } from 'react';

export interface AssistantGlyphProps {
  size?: number;
}

/**
 * Code-native pixel sparkle for the assistant — the pixelated sibling of the
 * old `✦` glyph. Monochrome via `currentColor` so the launcher/header colour
 * (and its hover inversion) drives the fill; no external image assets.
 * Follows the CardGlyph convention: 9×9 grid, crisp edges, 1×1 rects.
 */
const ROWS: readonly string[] = [
  '....#....',
  '....#....',
  '...###...',
  '..#####..',
  '#########',
  '..#####..',
  '...###...',
  '....#....',
  '....#....',
];

export function AssistantGlyph({ size = 22 }: AssistantGlyphProps): ReactElement {
  return (
    <svg
      viewBox="0 0 9 9"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      shapeRendering="crispEdges"
      className="cards-ai-glyph"
    >
      {ROWS.flatMap((row, y) => [...row].map((pixel, x) => (
        pixel === '#'
          ? <rect key={`${x}:${y}`} x={x} y={y} width="1" height="1" fill="currentColor" />
          : null
      )))}
    </svg>
  );
}
